var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileshare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.66406 5.83203L8.46816 10.5949C9.01914 10.9806 9.29463 11.1734 9.59428 11.2481C9.85898 11.3141 10.1358 11.3141 10.4005 11.2481C10.7002 11.1734 10.9757 10.9806 11.5266 10.5949L18.3307 5.83203M5.66406 16.6654H14.3307C15.7309 16.6654 16.4309 16.6654 16.9657 16.3929C17.4361 16.1532 17.8186 15.7707 18.0582 15.3003C18.3307 14.7656 18.3307 14.0655 18.3307 12.6654V7.33203C18.3307 5.9319 18.3307 5.23183 18.0582 4.69705C17.8186 4.22665 17.4361 3.8442 16.9657 3.60451C16.4309 3.33203 15.7309 3.33203 14.3307 3.33203H5.66406C4.26393 3.33203 3.56387 3.33203 3.02909 3.60451C2.55868 3.8442 2.17623 4.22665 1.93655 4.69705C1.66406 5.23183 1.66406 5.9319 1.66406 7.33203V12.6654C1.66406 14.0655 1.66406 14.7656 1.93655 15.3003C2.17623 15.7707 2.55868 16.1532 3.02909 16.3929C3.56387 16.6654 4.26393 16.6654 5.66406 16.6654Z",
    stroke: "#6366F1",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileshare);
export default __webpack_public_path__ + "static/media/fileshare.03c70b5f59f3d0fa249653db0c48311b.svg";
export { ForwardRef as ReactComponent };